const sendMail = () => {
  const email = 'info@wisedoc.net';
  const subject = 'Schedule a Call';
  const emailBody = ' ';
  document.location = `mailto:${email}?subject=${subject}&body=${emailBody}`;
};

export default sendMail;
